(function () {
  "use strict";

  var GLOBAL_KEY = "BotanicalisProductTools";
  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initialize();
    return;
  }

  function query(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function queryAll(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function normalizedDimension(value) {
    return String(value == null ? "" : value)
      .replace(/\u00a0/g, " ")
      .trim()
      .toLowerCase();
  }

  function numberFromText(value) {
    var number = Number(String(value == null ? "" : value).trim().replace(",", "."));
    return Number.isFinite(number) && number > 0 ? number : null;
  }

  function exactDimension(value) {
    var match = normalizedDimension(value).match(/^(\d+(?:[.,]\d+)?)\s*(?:cm)?$/i);
    return match ? numberFromText(match[1]) : null;
  }

  function upperDimension(value) {
    var exact = exactDimension(value);
    if (exact !== null) return exact;

    var match = normalizedDimension(value).match(/^(\d+(?:[.,]\d+)?)\s*(?:cm)?\s*(?:-|\u2013|\u2014|a\u017e)\s*(\d+(?:[.,]\d+)?)\s*(?:cm)?$/i);
    if (!match) return null;

    var first = numberFromText(match[1]);
    var second = numberFromText(match[2]);
    return first !== null && second !== null ? Math.max(first, second) : null;
  }

  function formatNumber(value) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "sk-SK", {
        maximumFractionDigits: 1
      }).format(value);
    } catch (error) {
      return String(value);
    }
  }

  function formatMoneyFromCents(value) {
    var amount = Number(value) / 100;
    if (!Number.isFinite(amount)) return "";

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : "EUR";

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "sk-SK", {
        style: "currency",
        currency: currency
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + " " + currency;
    }
  }

  function setInvalid(input, invalid) {
    if (!input) return;
    input.setAttribute("aria-invalid", invalid ? "true" : "false");
  }

  function clearResultOnInput(form, result) {
    if (!form || !result) return;
    form.addEventListener("input", function (event) {
      result.hidden = true;
      result.removeAttribute("data-state");
      if (event.target instanceof HTMLInputElement) setInvalid(event.target, false);
    });
  }

  function initializeFitChecker(checker) {
    if (!checker || checker.dataset.productFitReady === "true") return;
    checker.dataset.productFitReady = "true";

    var form = query("[data-fit-form]", checker);
    var heightInput = query("[data-fit-space-height]", checker);
    var widthInput = query("[data-fit-space-width]", checker);
    var widthField = query("[data-fit-width-field]", checker);
    var widthHint = query("[data-fit-width-hint]", checker);
    var result = query("[data-fit-result]", checker);
    var productHeight = numberFromText(checker.dataset.productHeight);
    var productWidth = upperDimension(checker.dataset.productWidth);
    if (!form || !heightInput || !widthInput || !result || productHeight === null) return;

    if (productWidth === null) {
      widthInput.disabled = true;
      widthInput.required = false;
      if (widthField) widthField.setAttribute("aria-disabled", "true");
      if (widthHint) widthHint.textContent = "Pri tomto produkte nemáme jednoznačnú šírku. Kontrola preto vyhodnotí iba výšku.";
    } else {
      widthInput.required = true;
      if (widthHint) widthHint.textContent = "Kontrola použije šírku " + formatNumber(productWidth) + " cm. Pri intervale ide o jeho hornú hranicu.";
    }

    clearResultOnInput(form, result);
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var availableHeight = numberFromText(heightInput.value);
      var availableWidth = productWidth === null ? null : numberFromText(widthInput.value);
      var heightInvalid = availableHeight === null;
      var widthInvalid = productWidth !== null && availableWidth === null;

      setInvalid(heightInput, heightInvalid);
      setInvalid(widthInput, widthInvalid);
      result.hidden = false;

      if (heightInvalid || widthInvalid) {
        result.dataset.state = "error";
        result.textContent = "Zadajte kladný rozmer v centimetroch do každého aktívneho poľa.";
        (heightInvalid ? heightInput : widthInput).focus();
        return;
      }

      var heightFits = availableHeight >= productHeight;
      var widthFits = productWidth === null || availableWidth >= productWidth;
      var fits = heightFits && widthFits;
      var summary;
      var details = "Produkt potrebuje výšku " + formatNumber(productHeight) + " cm";

      if (productWidth !== null) {
        details += " a šírku " + formatNumber(productWidth) + " cm.";
        if (!heightFits && !widthFits) summary = "Podľa zadaných rozmerov sa produkt nezmestí na výšku ani na šírku.";
        else if (!heightFits) summary = "Podľa zadaných rozmerov sa produkt nezmestí na výšku.";
        else if (!widthFits) summary = "Podľa zadaných rozmerov sa produkt nezmestí na šírku.";
        else summary = "Podľa uvedených rozmerov sa produkt do priestoru zmestí.";
      } else {
        details += ". Šírku nevieme z dostupných údajov vyhodnotiť.";
        summary = heightFits
          ? "Podľa výšky sa produkt do priestoru zmestí."
          : "Podľa výšky sa produkt do priestoru nezmestí.";
      }

      result.dataset.state = fits ? "fits" : "does-not-fit";
      result.textContent = summary + " " + details;
    });
  }

  function initializePanelCalculator(calculator) {
    if (!calculator || calculator.dataset.panelCalculatorReady === "true") return;
    calculator.dataset.panelCalculatorReady = "true";

    var form = query("[data-panel-form]", calculator);
    var wallWidthInput = query("[data-wall-width]", calculator);
    var wallHeightInput = query("[data-wall-height]", calculator);
    var panelWidthInput = query("[data-panel-width-input]", calculator);
    var panelHeightInput = query("[data-panel-height-input]", calculator);
    var result = query("[data-panel-result]", calculator);
    var countNode = query("[data-panel-count]", calculator);
    var breakdownNode = query("[data-panel-breakdown]", calculator);
    var priceNode = query("[data-panel-price]", calculator);
    if (!form || !wallWidthInput || !wallHeightInput || !panelWidthInput || !panelHeightInput || !result) return;

    var knownPanelWidth = exactDimension(calculator.dataset.panelWidth);
    var knownPanelHeight = numberFromText(calculator.dataset.panelHeight);
    if (knownPanelWidth !== null && knownPanelHeight !== null) {
      if (!panelWidthInput.value) panelWidthInput.value = String(knownPanelWidth);
      if (!panelHeightInput.value) panelHeightInput.value = String(knownPanelHeight);
    }

    clearResultOnInput(form, result);
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var wallWidth = numberFromText(wallWidthInput.value);
      var wallHeight = numberFromText(wallHeightInput.value);
      var panelWidth = numberFromText(panelWidthInput.value);
      var panelHeight = numberFromText(panelHeightInput.value);
      var fields = [wallWidthInput, wallHeightInput, panelWidthInput, panelHeightInput];
      var values = [wallWidth, wallHeight, panelWidth, panelHeight];
      var firstInvalid = null;

      fields.forEach(function (input, index) {
        var invalid = values[index] === null;
        setInvalid(input, invalid);
        if (invalid && !firstInvalid) firstInvalid = input;
      });

      result.hidden = false;
      if (firstInvalid) {
        result.dataset.state = "error";
        if (countNode) countNode.textContent = "Doplňte všetky rozmery.";
        if (breakdownNode) breakdownNode.textContent = "Každý rozmer musí byť kladné číslo v centimetroch.";
        if (priceNode) priceNode.textContent = "";
        firstInvalid.focus();
        return;
      }

      var across = Math.ceil(wallWidth / panelWidth);
      var high = Math.ceil(wallHeight / panelHeight);
      var total = across * high;
      var unitPrice = Number(calculator.dataset.panelUnitPrice);

      result.dataset.state = "calculated";
      if (countNode) countNode.textContent = "Orientačne potrebujete " + total + " panelov.";
      if (breakdownNode) breakdownNode.textContent = across + " panelov na šírku × " + high + " panelov na výšku.";
      if (priceNode) {
        priceNode.textContent = Number.isFinite(unitPrice) && unitPrice >= 0
          ? "Odhad ceny panelov pri aktuálnom variante: " + formatMoneyFromCents(total * unitPrice) + "."
          : "Odhad ceny nie je pri tomto variante dostupný.";
      }
    });

    var productRoot = calculator.closest(".botanicalis-product") || document;
    var variantSelect = query('select[name="id"]', productRoot);
    if (variantSelect) {
      variantSelect.addEventListener("change", function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        if (option && option.dataset.priceCents) calculator.dataset.panelUnitPrice = option.dataset.priceCents;
        result.hidden = true;
      });
    }
  }

  function initializeVariantSelector(productRoot) {
    if (!productRoot || productRoot.dataset.productVariantReady === "true") return;
    productRoot.dataset.productVariantReady = "true";
    var variantSelect = query('select[name="id"]', productRoot);
    if (!variantSelect) return;

    variantSelect.addEventListener("change", function () {
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option || !option.dataset.priceCents) return;
      var formattedPrice = option.dataset.priceFormatted || formatMoneyFromCents(option.dataset.priceCents);
      var productCard = query("[data-product-card]", productRoot);
      var priceNode = query("[data-product-price]", productRoot);
      if (productCard) {
        productCard.dataset.variantId = option.value;
        productCard.dataset.price = formattedPrice;
      }
      if (priceNode) priceNode.textContent = formattedPrice;
    });
  }

  function initialize() {
    queryAll(".botanicalis-product").forEach(initializeVariantSelector);
    queryAll("[data-product-fit-checker]").forEach(initializeFitChecker);
    queryAll("[data-panel-calculator]").forEach(initializePanelCalculator);
  }

  window[GLOBAL_KEY] = { initialize: initialize };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", initialize);
})();
